import { Injectable } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmationDialogComponent} from '../component/confirmation-dialog/confirmation-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {

  constructor(public modalService: NgbModal) { }

  public confirm(
      title: string,
      message: string,
      btnOkText: string = 'OK',
      btnCancelText: string = 'Cancel',
      btnOkClass: string = 'btn btn-primary',
      btnCancelClass: string = 'btn btn-danger',
      dialogSize: 'sm'|'lg' = 'sm'): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationDialogComponent, { size: dialogSize });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.btnCancelClass = btnCancelClass;
    modalRef.componentInstance.btnOkClass = btnOkClass;

    return modalRef.result;
  }

}
